// จัดบริบทให้พอดี context ของโมเดลเล็ก: นับ token คร่าว ๆ แล้วตัดส่วนที่สำคัญน้อยก่อน
export const PROMPT_BUDGET = 1500; // token รวมของ system + ประวัติ + ข้อความผู้ใช้ (ไม่รวมคำตอบ)

/** ประมาณ token: ไทย ~0.6/ตัว, ละติน/ตัวเลข ~0.27/ตัว, อื่น ๆ (อีโมจิ/CJK) ~1/ตัว — ประมาณแบบเผื่อ */
export function estimateTokens(text) {
  let n = 0;
  for (const ch of String(text || "")) {
    const c = ch.codePointAt(0);
    if (c >= 0x0e00 && c <= 0x0e7f) n += 0.6;
    else if (c < 0x250) n += 0.27;
    else n += 1;
  }
  return Math.ceil(n) + 4; // +4 = โอเวอร์เฮดของ role/แท็ก
}

/** ตัดข้อความให้ไม่เกิน tokens (ตัดท้าย) */
export function clipToTokens(text, tokens) {
  const s = String(text || "");
  if (estimateTokens(s) <= tokens) return s;
  let lo = 0, hi = s.length;
  while (lo < hi) {
    const mid = Math.ceil((lo + hi) / 2);
    if (estimateTokens(s.slice(0, mid)) <= tokens) lo = mid;
    else hi = mid - 1;
  }
  return s.slice(0, lo);
}

/**
 * sections: [{key, text, keep}] เรียงตามความสำคัญ (ตัวแรกสำคัญสุด) — ถ้า system ใหญ่เกินจะตัดจากท้ายก่อน
 * history: [{role, content}] เก่า->ใหม่ ; userTurn: ข้อความผู้ใช้ล่าสุด (null = history ลงท้ายด้วย user อยู่แล้ว)
 * minHistory = token ที่กันไว้ให้ประวัติอย่างน้อย
 * คืน {system, messages, tokens, dropped}
 */
export function fitPrompt({ sections, history = [], userTurn = null, budget = PROMPT_BUDGET, minHistory = 350 }) {
  const secs = (sections || []).filter((s) => s && s.text).map((s) => ({ ...s }));
  const sysTokens = () => estimateTokens(secs.map((s) => s.text).join("\n\n"));
  const sysBudget = Math.max(200, budget - minHistory);
  // ตัดจาก section ท้ายสุดก่อน (สำคัญน้อยสุด) จนระบบพอดี
  for (let i = secs.length - 1; i >= 0 && sysTokens() > sysBudget; i--) {
    if (secs[i].keep) continue;
    const others = estimateTokens(secs.filter((_, j) => j !== i).map((s) => s.text).join("\n\n"));
    const room = sysBudget - others;
    secs[i].text = room > 30 ? clipToTokens(secs[i].text, room) : "";
  }
  // ถ้ายังเกิน (ส่วน keep ใหญ่เอง) ตัด keep ท้ายสุดลง
  for (let i = secs.length - 1; i >= 0 && sysTokens() > sysBudget; i--) {
    const others = estimateTokens(secs.filter((_, j) => j !== i).map((s) => s.text).join("\n\n"));
    secs[i].text = clipToTokens(secs[i].text, Math.max(40, sysBudget - others));
  }
  const system = secs.filter((s) => s.text).map((s) => s.text).join("\n\n");
  let left = budget - estimateTokens(system);

  const msgs = [];
  if (userTurn !== null) {
    const u = clipToTokens(userTurn, Math.max(60, Math.min(left, 500)));
    msgs.push({ role: "user", content: u });
    left -= estimateTokens(u);
  }
  let dropped = 0;
  for (let i = history.length - 1; i >= 0; i--) {
    const m = history[i];
    let c = String(m.content || "");
    const t = estimateTokens(c);
    if (t > left) {
      // ข้อความล่าสุดของประวัติยาวเกิน: ใส่เท่าที่ได้ ที่เหลือทิ้ง
      if (msgs.length === 0 && left > 60) {
        c = clipToTokens(c, left);
        msgs.unshift({ role: m.role, content: c });
        left -= estimateTokens(c);
        dropped += i;
      } else dropped += i + 1;
      break;
    }
    msgs.unshift({ role: m.role, content: c });
    left -= t;
  }
  // รวม role ติดกัน + ต้องเริ่มด้วย user
  const out = [];
  msgs.forEach((m) => {
    const last = out[out.length - 1];
    if (last && last.role === m.role) last.content += "\n" + m.content;
    else out.push({ ...m });
  });
  while (out.length && out[0].role !== "user") {
    out.shift();
    dropped++;
  }
  if (!out.length) out.push({ role: "user", content: "(เริ่มบทสนทนา)" });
  const tokens = estimateTokens(system) + out.reduce((a, m) => a + estimateTokens(m.content), 0);
  return { system, messages: out, tokens, dropped };
}
